module.exports = __webpack_public_path__ + "media/images/weather/63_day-77dc0c3aa79cbbeaa08fe1158b050c8e.png";